export default __webpack_public_path__ + "static/rh-main-3-2e8d922f8060e7e3886b728a781364f6.jpg";